/**
 * Render a plain-DOM error screen when React itself can't mount.
 * Called from main.tsx's try/catch. Uses safe DOM methods (no innerHTML).
 */
export function renderFatalError(error: unknown) {
  const err =
    error instanceof Error ? error : new Error(String(error ?? "Unknown error"));

  const root = document.getElementById("root");
  if (!root) return;

  // Clear existing content safely
  while (root.firstChild) root.removeChild(root.firstChild);

  const container = el("div", {
    style: "display:flex;min-height:100vh;align-items:center;justify-content:center;background:#09090b;padding:24px;font-family:system-ui,sans-serif",
  });

  const card = el("div", { style: "width:100%;max-width:672px" });

  // Error box
  const errorBox = el("div", {
    style: "border:1px solid rgba(239,68,68,0.3);background:rgba(239,68,68,0.1);border-radius:12px;padding:16px 20px",
  });
  const title = el("p", {
    style: "font-size:14px;font-weight:600;color:#f87171;margin:0",
  });
  title.textContent = "Application failed to start";
  const message = el("p", {
    style: "font-size:12px;font-family:monospace;color:#fca5a5;margin:4px 0 0;word-break:break-all",
  });
  message.textContent = err.message;
  errorBox.append(title, message);

  // Reload button
  const btn = el("button", {
    style: "margin-top:16px;padding:8px 12px;font-size:12px;font-weight:500;color:#d4d4d8;background:#27272a;border:none;border-radius:8px;cursor:pointer",
  });
  btn.textContent = "Reload page";
  btn.addEventListener("click", () => location.reload());

  card.append(errorBox, btn);

  // Stack trace
  if (err.stack) {
    const details = document.createElement("details");
    details.style.cssText = "margin-top:16px;color:#a1a1aa";
    const summary = document.createElement("summary");
    summary.style.cssText = "font-size:12px;cursor:pointer";
    summary.textContent = "Stack trace";
    const pre = el("pre", {
      style: "margin-top:8px;overflow:auto;border:1px solid #27272a;background:#18181b;border-radius:12px;padding:16px;font-size:11px;line-height:1.6;white-space:pre-wrap;word-break:break-all",
    });
    pre.textContent = err.stack;
    details.append(summary, pre);
    card.append(details);
  }

  container.append(card);
  root.append(container);
}

function el(tag: string, attrs: Record<string, string>): HTMLElement {
  const node = document.createElement(tag);
  if (attrs.style) node.style.cssText = attrs.style;
  return node;
}
